import React from "react";
import { LegalPage } from "../../components/marketing/LegalPage";
import { privacySections } from "../../data/legal";
export function Privacy() {
  return <LegalPage title="Privacy Policy" updated="September 1, 2026" sections={privacySections} data-id="element-1917" data-mp="zoaeaiuvhvmb" />;
}